import * as React from 'react';
import { observer, inject } from 'mobx-react';
import { CSSTransitionGroup } from 'react-transition-group';
import * as classNames from 'classnames';
import { IAppOnlyStore } from 'stores/AllStores';
import { SidebarType } from 'stores/Sidebar';
import { SidebarContent, ProfileSidebar } from '.';

// Styles
const s = require('./Sidebar.css');

// Component
@inject('store')
@observer
export class Sidebar extends React.Component<IAppOnlyStore, {}> {
    constructor(props: IAppOnlyStore) {
        super(props);
    }

    public render() {
        const { sidebar } = this.props.store;

        return (
            <div
                onClick={this.handleSidebarClose}
                className={classNames(s.sidebar, {
                    [s.open]: sidebar.open !== SidebarType.Closed,
                })}
            >
                <div
                    onClick={this.preventSidebarClose}
                    ref={this.referenceInner}
                    className={s.inner}
                    style={{
                        width: sidebar.open !== SidebarType.Closed && sidebar.width
                            ? sidebar.width + 'px'
                            : '0px',
                    }}
                >

                    <CSSTransitionGroup
                        component="div"
                        className={s.transitionGroup}
                        transitionName="sidebar"
                        transitionAppear={true}
                        transitionAppearTimeout={400}
                        transitionEnter={true}
                        transitionEnterTimeout={400}
                        transitionLeave={true}
                        transitionLeaveTimeout={400}
                    >

                        {(sidebar.open === SidebarType.Profile) && (
                            <SidebarContent
                                key="profile"
                                title="Profile"
                                width={sidebar.width}
                                onClose={this.handleSidebarClose}
                            >
                                <ProfileSidebar />
                            </SidebarContent>
                        )}

                    </CSSTransitionGroup>

                </div>
            </div>
        );
    }

    private referenceInner = (ref: HTMLDivElement) => this.inner = ref;
    private inner: HTMLDivElement = null;

    private handleScrollInnerToTop = () => {
        if (this.inner) {
            this.inner.scrollTop = 0;
        }
    }

    private handleSidebarClose = (e: React.MouseEvent<HTMLDivElement | HTMLButtonElement>) => {
        this.props.store.sidebar.closeSidebar();
        this.props.store.user.userChangePassword = false;
        this.props.store.user.userEdit = false;
    }

    private preventSidebarClose = (e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/layout/Sidebar/Sidebar.tsx